var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarBlueBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 18,
    rx: 17.5,
    ry: 18,
    fill: "#3D4C66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.0007C19.2496 18.0007 20.6667 16.509 20.6667 14.6673C20.6667 12.8257 19.2496 11.334 17.5 11.334C15.7504 11.334 14.3333 12.8257 14.3333 14.6673C14.3333 16.509 15.7504 18.0007 17.5 18.0007ZM17.5 19.6673C15.3863 19.6673 11.1667 20.784 11.1667 23.0007V24.6673H23.8333V23.0007C23.8333 20.784 19.6138 19.6673 17.5 19.6673Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBlueBackground);
export default __webpack_public_path__ + "static/media/Avatar-Blue_Background.75aad541dd957b97cd8aab52dd728958.svg";
export { ForwardRef as ReactComponent };